<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 渠道管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-tag>客户状态：</el-tag>
                <template>
                    <el-button v-if="query.stateType==1" @click="getDistByAreaState(1,query.provinceId,query.cityId,1)"
                               icon="el-icon-user" class="area" type="primary">待开发
                    </el-button>
                    <el-button v-else @click="getDistByAreaState(1,query.provinceId,query.cityId,1)" icon="el-icon-user"
                               class="area">待开发
                    </el-button>
                </template>

                <template>
                    <el-button v-if="query.stateType==2"
                               @click="getDistByAreaState(2,query.provinceId,query.cityId,1)" icon="el-icon-user"
                               class="area" type="primary">沟通中
                    </el-button>
                    <el-button v-else @click="getDistByAreaState(2,query.provinceId,query.cityId,1)"
                               icon="el-icon-user" class="area">沟通中
                    </el-button>
                </template>
                <template>
                    <el-button v-if="query.stateType==3"
                               @click="getDistByAreaState(3,query.provinceId,query.cityId,1)" icon="el-icon-user"
                               class="area" type="primary">已合作
                    </el-button>
                    <el-button v-else @click="getDistByAreaState(3,query.provinceId,query.cityId,1)" class="area"
                               icon="el-icon-user">已合作
                    </el-button>
                </template>
                <template>
                    <el-button v-if="query.stateType==0"
                               @click="getDistByAreaState(0,query.provinceId,query.cityId,1)" icon="el-icon-user"
                               class="area" type="primary">暂放弃
                    </el-button>
                    <el-button v-else @click="getDistByAreaState(0,query.provinceId,query.cityId,1)" class="area"
                               icon="el-icon-user">暂放弃
                    </el-button>
                </template>
                <template>
                    <el-button v-if="query.stateType==10"
                               @click="getDistByAreaState(10,query.provinceId,query.cityId,1)" icon="el-icon-user"
                               class="area" type="primary">待删除
                    </el-button>
                    <el-button v-else @click="getDistByAreaState(10,query.provinceId,query.cityId,1)" class="area"
                               icon="el-icon-user">待删除
                    </el-button>
                </template>
                <el-tag style=" margin:0px 20px 0px 300px">客户搜索：</el-tag>
                <el-select class="handle-select mr10" placeholder="搜索方式" v-model="search.type">
                    <el-option
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            v-for="item in SearchType">
                    </el-option>
                </el-select>
                <el-input class="handle-input mr10" clearable placeholder="关键字" v-model="search.keyword"></el-input>
                <el-button @click="getSearch" icon="el-icon-search" type="success">搜索</el-button>
                <el-button @click="getLoginData" icon="el-icon-user" style="margin-right: 20px;">联系人搜索</el-button>

            </div>

            <div class="handle-box">
                <el-tag>省级区域：</el-tag>
                <template v-for="item in province">
                    <el-button v-if="item.Id==query.provinceId"
                               @click="getDistByAreaState(query.stateType,item.Id,0,1)" class="area" type="primary">
                        {{item.Cname}}
                    </el-button>
                    <el-button v-else @click="getDistByAreaState(query.stateType,item.Id,0,1)" class="area">
                        {{item.Cname}}
                    </el-button>
                </template>
            </div>
            <div v-if="cityDisplay" class="handle-box">
                <el-tag>市级区域：</el-tag>
                <template v-for="item in city">
                    <el-button v-if="item.Id==query.cityId"
                               @click="getDistByAreaState(query.stateType,item.Cpid,item.Id,1)" class="area"
                               type="primary">{{item.Cname}}
                    </el-button>
                    <el-button v-else @click="getDistByAreaState(query.stateType,item.Cpid,item.Id,1)" class="area">
                        {{item.Cname}}
                    </el-button>
                </template>

            </div>

            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="Id" width="90"></el-table-column>
                <el-table-column align="left" label="机构名称" prop="Cname"></el-table-column>
                <el-table-column align="center" label="添加/合作时间" prop="Cdatetime"></el-table-column>
                <el-table-column label="所属销售" prop="Cperson"></el-table-column>
                <el-table-column align="center" label="所属分类" prop="sizeName"></el-table-column>
                <el-table-column align="center" label="所处状态" prop="Cstate">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Cstate===0?'danger':(scope.row.Cstate===1?'info':(scope.row.Cstate===2?'warning':(scope.row.Cstate===3?'success':'danger')))"
                        >
                            {{scope.row.Cstate===0?'暂放弃':(scope.row.Cstate===1?'待开发':(scope.row.Cstate===2?'沟通中':(scope.row.Cstate===3?'已合作':'待删除')))}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button
                                @click="editInfo(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <el-button
                                @click="editPerson(scope.$index, scope.row)"
                                icon="el-icon-user"
                                type="text"
                        >增加联系人
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 2026 渠道资料修改 -->
        <el-dialog :visible.sync="edit_info_vis" title="添加/编辑渠道详情" width="50%">
            <el-form :model="form" label-width="80px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="机构名称">
                            <el-input class='wd200' v-model="form.Cname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="所属区域">
                            <el-cascader v-model="form.Ccity"
                                         :options="areaOption"
                                         :props="{ checkStrictly: true }"
                                         clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="机构规模">
                            <el-select placeholder="请选择" v-model="form.Csize">
                                <el-option :key="item.Id"
                                           :label="item.Cname"
                                           :value="item.Id"
                                           class="wd200"
                                           v-for="item in clientSizeOpt">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="最近合作">
                            <el-date-picker
                                    v-model="form.Cdatetime"
                                    type="date"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="所属销售">
                            <el-select placeholder="请选择" v-model="form.Csales">
                                <el-option :key="item.Id"
                                           :label="item.Uname"
                                           :value="item.Id"
                                           class="wd200"
                                           v-for="item in clientSalesOpt">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="业务范围">
                            <el-select
                                    v-model="clientScope"
                                    multiple
                                    filterable
                                    default-first-option
                                    placeholder="请选择标签属性">
                                <el-option
                                        v-for="item in clientScopeOpt"
                                        :key="item.Id"
                                        :label="item.Cname"
                                        :value="item.Id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="业务类型">
                            <el-select
                                    v-model="clientType"
                                    multiple
                                    filterable
                                    default-first-option
                                    placeholder="请选择标签属性">
                                <el-option
                                        v-for="item in clientTypeOpt"
                                        :key="item.Id"
                                        :label="item.Cname"
                                        :value="item.Id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="所属状态">
                            <el-select placeholder="请选择" v-model="form.Cstate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           class="wd200"
                                           v-for="item in clientStateOpt">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="主联系人">
                            <el-input class='wd200' v-model="form.Cperson"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="联系电话">
                            <el-input class='wd200' v-model="form.Cphone"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="性别">
                            <el-radio-group v-model="form.Csex">
                                <el-radio :label="0">女</el-radio>
                                <el-radio :label="1">男</el-radio>
                                <!--                                <el-radio :label="2">保密</el-radio>-->
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="微信号码">
                            <el-input class='wd200' v-model="form.Cwechat"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客户来源">
                            <el-input class='wd200' v-model="form.Ctheme"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="账号信息">{{form.Cid}}-{{form.Cidtype===0?'公众号-订阅':(form.Cidtype===1?'公众号':'服务号')}}/
                            {{form.Cidstate===0?'未认证':(form.Cidstate===1?'黄标认证':(form.Cidstate===2?'蓝标认证':'带V标识'))}}
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="16">
                        <el-form-item label="办公地址">
                            <el-input v-model="form.Cadd"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客户等级">
                            <el-select placeholder="请选择" v-model="form.Clevel">
                                <el-option :key="item.Id"
                                           :label="item.Cname"
                                           :value="item.Id"
                                           class="wd200"
                                           v-for="item in clientLevelOpt">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-form-item label="备注说明">
                    <el-input
                            maxlength="5000"
                            placeholder="请输入内容"
                            rows="5"
                            show-word-limit
                            type="textarea"
                            v-model="form.Cmemo"
                    ></el-input>
                </el-form-item>
                <el-row :gutter="20">
                    <el-col :span="20">
                        <el-form-item label="本次日志">
                            <el-input v-model="form.Note"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <el-button @click="saveCmemo" type="primary" plain>保存新的日志</el-button>
                    </el-col>
                </el-row>

                <el-row :gutter="20" v-for="(item, index) in NoteList" :key="index">
                    <el-col :span="15">
                        <el-form-item :label="index+1">
                            <el-input v-model="item.Ccontext" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9">
                        跟踪人：{{item.CuserName}}，添加时间：{{item.Ctime}}
                    </el-col>
                </el-row>

            </el-form>
            <el-descriptions class="marginTop10" :column="3" border v-for="(person, index) in personList" :key="index">
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        用户名
                    </template>
                    {{person.Cname}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        手机号
                    </template>
                    {{person.Cphone}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-chat-dot-square"></i>
                        微信号
                    </template>
                    {{person.Cwechat}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        添加人
                    </template>
                    {{person.userName}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        添加时间
                    </template>
                    {{person.Cdatetime}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        备注
                    </template>
                    {{person.Cmemo}}
                </el-descriptions-item>
            </el-descriptions>

            <span class="dialog-footer" slot="footer">
                <el-button @click="edit_info_vis = false">取 消</el-button>
                <el-button @click="saveClent" type="primary">保 存</el-button>
            </span>
        </el-dialog>

        <!-- 2026 渠道更多联系人信息 -->
        <el-dialog :visible.sync="edit_person_vis" title="管理机构/渠道联系人信息" width="90%">
            <el-form :model="form" label-width="70px" ref="form">

                <el-row :gutter="24" v-for="(person, index) in personList" :key="index">
                    <el-col :span="3">
                        <el-form-item label="姓名">
                            <el-input clearable v-model="person.Cname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="电话">
                            <el-input clearable v-model="person.Cphone"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="微信">
                            <el-input clearable v-model="person.Cwechat"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="职位类型">
                            <el-select placeholder="请选择" v-model="person.Crole">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in personRoleOpt"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="状态">
                            <el-select placeholder="请选择" v-model="person.Cstate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in personStateOpt"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="最近修改"><el-tag>{{person.userName}}</el-tag></el-form-item>
                    </el-col>

                    <el-col :span="5">
                        <el-form-item label="备注说明">
                            <el-input clearable v-model="person.Cmemo"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1">
                        <el-button type="primary" @click="updatePerson(person)">保存</el-button>
                    </el-col>
                </el-row>
                <el-button @click="addPerson()">+新增联系人</el-button>
            </el-form>

        </el-dialog>




    </div>
</template>

<script>

    export default {
        name: 'basetable',
        data() {
            return {
                search: {
                    keyword: '',
                    type: '2'
                },
                SearchType: [
                    { name: '机构名称', id: '1' },
                    { name: '个人姓名', id: '2' },
                    { name: '手机号码', id: '3' },
                    { name: '微信号码', id: '4' }
                ],
                query: {
                    stateType: -1,
                    provinceId: '',
                    cityId: '',
                    pageSize: 15,
                    pageIndex: 1,
                    uid: 0
                },
                province: [],
                city: [],
                cityDisplay: false,
                pageTotal: 0,
                edit_info_vis: false,
                areaOption: [],
                clientSizeOpt: [],
                clientSalesOpt: [],
                clientScopeOpt: [],
                clientScope: [],
                clientTypeOpt: [],
                clientType: [],
                clientLevelOpt: [],
                clientStateOpt: [
                    { value: 0, label: '暂放弃' },
                    { value: 1, label: '待开发' },
                    { value: 2, label: '沟通中' },
                    { value: 3, label: '已合作' },
                    { value: 10, label: '待删除' }
                ],
                mpTypeOpt: [
                    { value: 0, label: '公众号-订阅' },
                    { value: 1, label: '公众号' },
                    { value: 2, label: '服务号' },
                ],
                mpStateOpt: [
                    { value: 0, label: '未认证' },
                    { value: 1, label: '黄标认证' },
                    { value: 2, label: '蓝标认证' },
                    { value: 3, label: '带V标识' },
                ],
                edit_person_vis:false,
                personList:[],
                personType:[],
                personRoleOpt:[
                    { value: 1, label: '客服' },
                    { value: 2, label: '销售' },
                    { value: 3, label: '计调' },
                    { value: 4, label: '财务' },
                    { value: 5, label: '领队' },
                    { value: 6, label: '经理人' },
                    { value: 7, label: '老板/创始人' }
                ],
                personStateOpt:[
                    { value: 0, label: '待删除' },
                    { value: 1, label: '已离职' },
                    { value: 2, label: '正常在职'}
                ],
                NoteList:[],

                tableData: [],
                loginData: [],
                multipleSelection: [],
                form: {},
                idx: -1,
                id: -1
            };
        },
        created() {
            this.getUserAeraData();
            this.getDistByAreaState(1, 0, 0, 1);
        },
        components: {
            'remote-js': {
                render(createElement) {
                    return createElement('script', { attrs: { type: 'text/javascript', src: this.src } });
                },
                props: {
                    src: { type: String, required: true }
                }
            }
        },

        methods: {
            //2026 获取 登录用户所拥有 省份数据
            async getUserAeraData() {
                const { data: res } = await this.$http.post('admin/client/getUserPerArea', {
                    uid: sessionStorage.getItem('yp_userid')
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                }
                this.province = res.list;
                // this.$message.success('【省份列表】数据加载成功!');
            },

            //2026 条件筛选 显示
            async getDistByAreaState(state, pid, cid, index) {
                this.query.stateType = state;
                this.query.provinceId = pid;
                this.query.cityId = cid;
                this.query.pageIndex = index;
                this.query.uid = sessionStorage.getItem('yp_userid');
                if (pid != 0 && cid == 0) {
                    this.cityDisplay = true;
                    const { data: res } = await this.$http.post('admin/client/getAreaByProvince', {
                        pid: pid
                    });
                    if (res.code !== 200) {
                        return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                    }
                    this.city = res.list;
                }
                const { data: res } = await this.$http.post('admin/client/getDistByAreaState', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                }

                this.areaOption = res.areaOption;
                this.clientSalesOpt=res.sales;
                this.clientSizeOpt = res.sizeTags;
                this.clientScopeOpt = res.scopeTags;
                this.clientTypeOpt = res.typeTags;
                this.clientLevelOpt = res.levelTags;

                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.$message.success('【渠道】数据加载成功!');
            },

            // 2026 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getDistByAreaState(this.query.stateType, this.query.provinceId, this.query.cityId, val);
            },

            // 2026 编辑修改 渠道详细信息
            async editInfo(index, row) {
                this.idx = index;
                this.form = row;
                this.edit_info_vis = true;
                const { data: res } = await this.$http.post('/admin/client/getClientPro', {
                    cid: this.form.Id
                });
                this.clientScope=res.Scope;
                this.clientType=res.Type;
                this.personList=res.Person;
                this.NoteList = res.Note;
            },

            // 2026 修改渠道客户信息
            async saveClent() {
                const { data: res } = await this.$http.post('/admin/client/addClient', {
                    form: this.form,
                    clientScope: this.clientScope,
                    clientType: this.clientType
                });
                if (res.code !== 200) {
                    this.edit_info_vis = false;
                    return this.$message.error('系统错误，用户操作失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.edit_info_vis = false;
            },
            // 2026 保存跟踪日志
            async saveCmemo(){
                const { data: res } = await this.$http.post('/admin/client/addCmemo', {
                    Cpid: this.form.Id,
                    Ccontext: this.form.Note,
                    Cuser: sessionStorage.getItem('yp_userid'),
                    CuserName:sessionStorage.getItem('yp_username')
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，用户操作失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.NoteList = res.list;
            },

            // 2026 编辑修改 渠道联系人信息
            async editPerson(index, row) {
                this.idx = index;
                this.form = row;
                this.edit_person_vis = true;
                const { data: res } = await this.$http.post('/admin/client/getClientPerson', {
                    cid: this.form.Id
                });
                this.personList = res.list;
            },

            //2026 搜索渠道信息
            async getSearch() {
                if (this.search.keyword.length < 2) {
                    return this.$message.error('请输入检索关键字【大于2位】!');
                } else {
                    const { data: res } = await this.$http.post('admin/client/searchClient', {
                        search: this.search
                    });
                    if (res.code !== 200) {
                        return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                    }
                    this.tableData = res.list;
                    this.pageTotal = res.pageTotal;
                    this.$message.success('数据加载成功!');
                }
            },
            // 2026 修改联系人
            async updatePerson(person){
                const { data: res } = await this.$http.post('admin/client/updateClientPerson', {
                    Id: person.Id,
                    Cid:this.form.Id,
                    Cname: person.Cname,
                    Cphone: person.Cphone,
                    Cwechat:person.Cwechat,
                    Cmemo: person.Cmemo,
                    Crole: person.Crole,
                    Cstate:person.Cstate,
                    Cuser:sessionStorage.getItem('yp_userid')
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                }
                this.personList = res.list;
                this.$message.success('联系人-修改成功!');
            },

            // 2026 增加联系人
            async addPerson(){
                const { data: res } = await this.$http.post('admin/client/addClientPerson', {
                    cid: this.form.Id,
                    uid:sessionStorage.getItem('yp_userid')
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                }
                this.personList = res.list;
                this.$message.success('联系人-添加成功!');
            },

            async getLoginData() {
                this.query.day = 1;
                const { data: res } = await this.$http.post('admin/client/initUserData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                }
                this.tableData = res.data.list;
                this.pageTotal = res.data.pageTotal || 25;
                this.$message.success('【LoginUserData列表】数据加载成功!');
            },


            // 触发搜索按钮
            handleSearch() {
                this.$set(this.query, 'pageIndex', 1);
                //this.getData();
            },

            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            }
        }
    };
</script>

<style scoped>

    .wechat-name-wrapper {
        display: inline-flex;
        align-items: center;
        min-width: 0; /* 修复flex容器文本溢出问题 */
    }

    .auth-badge {
        margin-top: 10px;
        margin-right: 40px;
        flex-shrink: 0; /* 防止徽章被压缩 */
    }

    .name-text {
        color: #333;
        font-size: 14px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .item {
        margin-top: 10px;
        margin-right: 40px;
    }

    .wd200 {
        width: 220px;
    }

    .handle-box {
        margin-bottom: 10px;
    }

    .handle-box .area {
        margin: 5px 10px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .green {
        color: #00a854;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .permission-row {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
        padding: 10px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
    }

    .city-name {
        width: 70px;
        font-weight: bold;
        line-height: 36px;
    }

    .permission-group {
        flex: 1;
        display: flex;
    }

    .permission-group .el-checkbox {
        margin-right: 15px;
    }

    .form-fields {
        width: 100%;
        display: flex;
        margin-top: 10px;
    }

    .validity-item {
        flex: 1;
        margin-right: 10px;
    }

    .vip-item {
        flex: 1;
    }

    .wd200 {
        width: 200px;
    }

    .dialog-footer {
        display: flex;
        justify-content: flex-end;
    }

    .marginTop10 {
        margin-top: 20px;
    }
</style>
